<template>
    <div class="analyzing">
        <div class="left">
            <div class="top">
                <div class="item">
                    <p class="itemtitle">呼吸频率采样图</p>
                    <div ref="peopleNumByDegree1" style="width: 100%;height:280px"></div>
                </div>
                <div class="item">
                    <p class="itemtitle color02">吸气时间采样图</p>
                    <div ref="peopleNumByDegree2" style="width: 100%;height:280px"></div>
                </div>
                <div class="item">
                    <p class="itemtitle color03">呼吸时间采样图</p>
                    <div ref="peopleNumByDegree3" style="width: 100%;height:280px"></div>
                </div>
                <div class="item">
                    <p class="itemtitle color04">呼气时间采样图</p>
                    <div ref="peopleNumByDegree4" style="width: 100%;height:280px"></div>
                </div>
            </div>
            <div class="bottom">
                <p class="bigtitle">
                    <i><img src="@/assets/Analysissoftware/ic_breathe@2x.png"></i>
                    <span>呼吸反馈数据</span>
                </p>
                <div class="other">
                    <div class="item">
                        <div class="title"><img src="@/assets/Analysissoftware/bg_breathe_time@2x.png"></div>
                        <div class="content">
                            <i><img src="@/assets/Analysissoftware/bg_breathetime@2x.png"></i>
                            <div class="rightcontent">
                                <p class="text">正常范围</p>
                                <div class="Proportionbar">
                                    <div class="first"></div>
                                    <div class="center"></div>
                                    <div class="last"></div>
                                </div>
                                <p class="Score">
                                    <span>慢</span>
                                    <span>12</span>
                                    <span>24</span>
                                    <span>快</span>
                                </p>
                                <div class="list">
                                    <div class="items">
                                        <b>{{BreatheInfo.breathMax}}s</b>
                                        <p>最大值</p>
                                    </div>
                                    <div class="items">
                                        <b>{{BreatheInfo.breathMin}}s</b>
                                        <p>最小值</p>
                                    </div>
                                    <div class="items">
                                        <b>{{BreatheInfo.breathRate}}s</b>
                                        <p>平均值</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="title"><img src="@/assets/Analysissoftware/bg_breathe_frequency@2x.png"></div>
                        <div class="content">
                            <i><img src="@/assets/Analysissoftware/bg_breathetime@2x.png"></i>
                            <div class="rightcontent">
                                <p class="text">正常范围</p>
                                <div class="Proportionbar">
                                    <div class="first"></div>
                                    <div class="center"></div>
                                    <div class="last"></div>
                                </div>
                                <p class="Score">
                                    <span>慢</span>
                                    <span>3</span>
                                    <span>5</span>
                                    <span>快</span>
                                </p>
                                <div class="list">
                                    <div class="items">
                                        <b>{{BreatheInfo.respiratoryRateMax}}s</b>
                                        <p>最大值</p>
                                    </div>
                                    <div class="items">
                                        <b>{{BreatheInfo.respiratoryRateMin}}s</b>
                                        <p>最小值</p>
                                    </div>
                                    <div class="items">
                                        <b>{{BreatheInfo.respiratoryRateAvg}}s</b>
                                        <p>平均值</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="right">
            <div class="Basicinfor">
                <label class="title">用户基本信息</label>
                <p class="item">部门：{{BreatheInfo.deptName}}</p>
                <p class="item">姓名：{{BreatheInfo.realName}}</p>
                <p class="item">性别：{{BreatheInfo.sex}}</p>
                <p class="item">年龄：{{BreatheInfo.age}}</p>
            </div>
            <div class="breathe">
                <p class="title">
                    <i><img src="@/assets/Analysissoftware/ic_percentage@2x.png"></i>
                    <span>呼吸比</span>
                </p>
                <div class="numerical">{{BreatheInfo.iERatio }}</div>
                <el-row class="Proportionbar">
                    <el-col :span="5"><div class="first"></div></el-col>
                    <el-col :span="14"><div class="center"></div></el-col>
                    <el-col :span="5"><div class="last"></div></el-col>
                </el-row>
                <p class="Score">
                    <span>低</span>
                    <span>1.15</span>
                    <span>正常值</span>
                    <span>1.25</span>
                    <span>高</span>
                </p>

            </div>

            <div class="inspiratorytime">
                <p class="title">
                    <i><img src="@/assets/Analysissoftware/ic_time@2x.png"></i>
                    <span>吸气时间</span>
                </p>
                <div class="average">
                    <i><img src="@/assets/Analysissoftware/puff_img01.png"></i>
                    <div>
                        <span>平均值</span>
                        <b>{{BreatheInfo.iSec}}</b>
                    </div>
                </div>
                <p class="title">
                    <i><img src="@/assets/Analysissoftware/ic_time@2x.png"></i>
                    <span>呼气时间</span>
                </p>
                <div class="average">
                    <i><img src="@/assets/Analysissoftware/puff_img02.png"></i>
                    <div>
                        <span>平均值</span>
                        <b>{{BreatheInfo.eSec}}</b>
                    </div>
                </div>
            </div>


        </div>
    </div>
</template>
<script>
export default{
    name:'analyzing',
    data() {
        return {
            BreatheInfo:{},
            userId:JSON.parse(sessionStorage.getItem('xinxi')).UserID,
            time:null
        }
    },
    created(){
        this.getBreatheInfo();
    },
    mounted() {
        var _this=this;
        this.time=setInterval(() => {
            _this.getBreatheInfo();
        }, 1000);
        
    },
    methods: {
        getBreatheInfo(){
            this.$Http_Post('/bioassay/soft/getBreatheInfo',{userId:this.userId}).then(res=>{
                if(res.Code==0){
                    this.BreatheInfo=res.Data;
                    this.respiratoryRates(res.Data.respiratoryRates);
                    this.inspiratoryTimes(res.Data.inspiratoryTimes);
                    this.breathTimes(res.Data.breathTimes);
                    this.expiratoryTimes(res.Data.expiratoryTimes);
                }else{
                    this.$message.error(res.Message);
                }
            })
        },
        // 呼吸频率
        respiratoryRates(data){
            let xdata=[];
            for(let item in data){xdata.push(item);}
            var myChart = this.$echarts.init(this.$refs.peopleNumByDegree1);
            var option = {
                tooltip: {
                    trigger: 'axis'
                },
                grid: {
                    top:20,
                    left: 40,  
                    bottom:30
                },
                xAxis: {
                    type: 'category',
                    data:xdata,
                    axisLine: {lineStyle: {color: '#fff'}},
                    splitLine: {show: false},  
                },
                yAxis: {
                    type: 'value',
                    axisLine: {lineStyle: {color: '#fff'}},
                    splitLine: {show: false},  
                },
                series:[
                    {
                        name:'呼吸频率',
                        data: data,
                        type: 'line',
                        smooth: true,
                        color: 'rgba(68, 185, 172, 1)'  
                
                    },
                ]
            };
            myChart.setOption(option);
            window.addEventListener("resize", function () {
                myChart.resize();
            });
        },
        // 吸气时间采样图
        inspiratoryTimes(data){
            let xdata=[];
            for(let item in data){xdata.push(item);}
            var myChart = this.$echarts.init(this.$refs.peopleNumByDegree2);
            var option = {
                tooltip: {
                    trigger: 'axis'
                },
                grid: {
                    top:20,
                    left: 40,  
                    bottom:30
                },
                xAxis: {
                    type: 'category',
                    data:xdata,
                    axisLine: {lineStyle: {color: '#fff'}},
                    splitLine: {show: false},  
                },
                yAxis: {
                    type: 'value',
                    axisLine: {lineStyle: {color: '#fff'}},
                    splitLine: {show: false},
                },
                series:[
                    {
                        name:'吸气时间',
                        data: data,
                        type: 'line',
                        smooth: true,
                        color: '#43CF7C'  
                
                    },
                ]
            };
            myChart.setOption(option);
            window.addEventListener("resize", function () {
                myChart.resize();
            });
        },
        // 呼吸时间采样图
        breathTimes(data){
            let xdata=[];
            for(let item in data){xdata.push(item);}
            var myChart = this.$echarts.init(this.$refs.peopleNumByDegree3);
            var option = {
                tooltip: {
                    trigger: 'axis'
                },
                grid: {
                    top:20,
                    left: 40,  
                    bottom:30
                },
                xAxis: {
                    type: 'category',
                    data:xdata,
                    axisLine: {lineStyle: {color: '#fff'}},
                    splitLine: {show: false},  
                },
                yAxis: {
                    type: 'value',
                    axisLine: {lineStyle: {color: '#fff'}},
                    splitLine: {show: false},   
                },
                series:[
                    {
                        name:'呼吸时间',
                        data: data,
                        type: 'line',
                        smooth: true,
                        color: '#FF8D1A'  
                
                    },
                ]
            };
            myChart.setOption(option);
            window.addEventListener("resize", function () {
                myChart.resize();
            });
        },
        // 呼气时间采样图
        expiratoryTimes(data){
            let xdata=[];
            for(let item in data){xdata.push(item);}
            var myChart = this.$echarts.init(this.$refs.peopleNumByDegree4);
            var option = {
                tooltip: {
                    trigger: 'axis'
                },
                grid: {
                    top:20,
                    left: 40,  
                    bottom:30
                },
                xAxis: {
                    type: 'category',
                    data:xdata,
                    axisLine: {lineStyle: {color: '#fff'}},
                    splitLine: {show: false},  
                },
                yAxis: {
                    type: 'value',
                    axisLine: {lineStyle: {color: '#fff'}},
                    splitLine: {show: false},   
                },
                series:[
                    {
                        name:'呼气时间',
                        data: data,
                        type: 'line',
                        smooth: true,
                        color: '#E3C21B'  
                
                    },
                ]
            };
            myChart.setOption(option);
            window.addEventListener("resize", function () {
                myChart.resize();
            });
        }
    },
    destroyed(){
        clearInterval(this.time);
    }
}
</script>
<style scoped>
.analyzing{background:url("../../../assets/Analysissoftware/puff_bg.png") no-repeat; background-size:100% 100%;width: 100%;min-height:100%;padding:15px 0;display: flex;}
.analyzing .left{width: calc(100% - 255px);display: inline-block;}
.analyzing .left .top{display: flex;flex-wrap: wrap;margin-right: 10px;}
.analyzing .left .top .item{height:320px;background: rgba(255, 255, 255, 0.05);width: calc( 50% - 2px);border-right: 2px solid #00264A;border-bottom: 2px solid #00264A;}
.analyzing .left .top .item .itemtitle{font-size: 16px;color: #43B8D9;border-bottom: 1px solid #43B8D9;margin: 0 5px 0 30px;padding:10px 0 10px;position: relative;}
.analyzing .left .top .item .itemtitle::before{content:'';width:10px;height: 10px;display: inline-block;border-radius: 50%;position: absolute;left: -5px;bottom: -5px;background: #43B8D9;}
.analyzing .left .top .item .itemtitle.color02::before{background: #43CF7C;}
.analyzing .left .top .item .itemtitle.color03::before{background: #FF8D1A;}
.analyzing .left .top .item .itemtitle.color04::before{background: #E3C21B;}
.analyzing .left .top .item:nth-child(2n){border-right: none;width: 50%;}
.analyzing .left .bottom{margin-right: 10px;}
.analyzing .left .bottom .bigtitle{background: #1A6073;font-size: 20px;color: #D6CC3A;display: flex;padding: 5px 15px;width: calc(100% - 30px);}
.analyzing .left .bottom .bigtitle i{width:26px;display: inline-block;margin-right:12px;}
.analyzing .left .bottom .other{display: flex;}
.analyzing .left .bottom .other .item{flex: 1;background: rgba(255, 255, 255, 0.05);}
.analyzing .left .bottom .other .item:first-child{margin-right:5px;}
.analyzing .left .bottom .other .item .title{padding: 16px 16px;width: 150px;}
.analyzing .left .bottom .other .item .content{display: flex;}
.analyzing .left .bottom .other .item .content i{width: 10vw;margin:0 16px;}
.analyzing .left .bottom .other .item .content .rightcontent{margin-top: -30px;flex: auto;}
.analyzing .left .bottom .other .item .content .rightcontent .text{text-align: center;font-size:18px;color: #39CC74;display:block;}
.analyzing .left .bottom .other .item .content .rightcontent .Proportionbar{height: 32px;margin:0 auto;display: flex;}
.analyzing .left .bottom .other .item .content .rightcontent .Proportionbar .first{background: #C9AE26;height:32px;width: 20%;}
.analyzing .left .bottom .other .item .content .rightcontent .Proportionbar .center{background: #168C46;height:32px;width:50%;}
.analyzing .left .bottom .other .item .content .rightcontent .Proportionbar .last{background: #E35636;height:32px;width: 20%;}
.analyzing .left .bottom .other .item .content .rightcontent .Score{display: flex;}
.analyzing .left .bottom .other .item .content .rightcontent .Score span{font-size:16px;flex:none;}
.analyzing .left .bottom .other .item .content .rightcontent .Score span:first-child{width:17%;color: #C9AE26;}
.analyzing .left .bottom .other .item .content .rightcontent .Score span:nth-child(2){width: 48%;color: #fff;}
.analyzing .left .bottom .other .item .content .rightcontent .Score span:nth-child(3){width: 18%;color: #fff;}
.analyzing .left .bottom .other .item .content .rightcontent .Score span:nth-child(4){color: #FF613D;}
.analyzing .left .bottom .other .item .content .rightcontent .list{display: flex;justify-content: space-between;margin: 30px 0;}
.analyzing .left .bottom .other .item .content .list .items{background: url("../../../assets/Analysissoftware/bg_square@2x.png") no-repeat;background-size: 100% 100%;text-align:center;padding: 16px 10px;flex: auto;margin: 0 5px;}
.analyzing .left .bottom .other .item .content .list .items p{font-size: 18px;color: #2BB361;}
.analyzing .left .bottom .other .item .content .list .items b{font-size:32px;color:#2BB361;display: block;min-width:40px;}
.analyzing .right{width: 240px;display: inline-block;}
.analyzing .Basicinfor{background:url("../../../assets/Analysissoftware/bg_personal@2x.png") no-repeat;height:360px;background-size: 100% 100%;width: 240px;}
.analyzing .Basicinfor .title{font-size: 22px;color: #fff;display: block;text-align: right;padding:5px 20px 20px 0;}
.analyzing .Basicinfor .item{font-size: 18px;color: #43B8D9;padding: 15px 0 0 20px;}
.analyzing .breathe{width: 100%;background: rgba(255, 255, 255, 0.05);margin:10px 0;padding: 10px 0;}
.analyzing .breathe .title{font-size: 20px;color: #43B8D9;line-height: 38px;display: flex;padding: 15px 10px;align-items: center;}
.analyzing .breathe .title i{width:30px;display: inline-block;margin-right: 12px;}
img{width: 100%;display: block;}
.analyzing .breathe .numerical{width: 110px;background: url('../../../assets/Analysissoftware/bg_rectangle@2x.png') no-repeat;background-size: 100% 100%;height:56px;line-height: 56px;text-align: center;margin: auto;font-size: 38px;color: #3FBF72;font-weight: bold;position: relative;}
.analyzing .breathe .numerical::after{content:'';width: 0;height: 0;border-left:5px solid transparent;border-right: 5px solid transparent;border-top:10px solid #3FBF72;position: absolute;bottom:-25px;left:50%;margin-left:-5px;}
.analyzing .breathe .Proportionbar{height:28px;margin:30px 5px 10px;}
.analyzing .breathe .Proportionbar .first{background: #C9AE26;height:28px;}
.analyzing .breathe .Proportionbar .center{background: #168C46;height:28px}
.analyzing .breathe .Proportionbar .last{background: #E35636;height:28px;}
.analyzing .breathe .Score{display: flex;padding: 5px 0;justify-content: space-around;}
.analyzing .breathe .Score span{font-size:18px;}
.analyzing .breathe .Score span:nth-child(1){color: #C9AE26;}
.analyzing .breathe .Score span:nth-child(2n){color: #8AA4BA;}
.analyzing .breathe .Score span:nth-child(3){color: #3FBF72;}
.analyzing .breathe .Score span:nth-child(5){color: #FF613D;}
.analyzing .inspiratorytime{background: rgba(255, 255, 255, 0.05);padding:10px 0 30px;}
.analyzing .inspiratorytime .title{font-size: 20px;color: #43B8D9;line-height: 38px;display: flex;padding: 10px 10px 20px;align-items: center}
.analyzing .inspiratorytime .title i{width: 30px;display: inline-block;margin-right: 12px;}
.analyzing  .inspiratorytime .average{background: url('../../../assets/Analysissoftware/bg_rectangle@2x.png') no-repeat;background-size: 100% 100%;margin:0 10px 15px;display: flex;align-items: center;}
.analyzing  .inspiratorytime .average:last-child{margin: 0 10px;}
.analyzing  .inspiratorytime .average i{width: 64px;display: inline-block;margin:0 30px;}
.analyzing  .inspiratorytime .average div span{font-size:18px;color: #239FC2;display: block;}
.analyzing  .inspiratorytime .average div b{font-size: 42px;color: #E3C21B;text-align: center;}
.analyzing .startBtn{width: 100%;margin: 10px 0;}
</style>